import React from "react";
import { Modal, Stack, Text, Group, Button } from "@mantine/core";
import { gray, primary, success } from "../../../../constants/color-constants";

interface ResetModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  previousRoute?: string;
  primaryColor?: string;
  open?: boolean; // New prop for re-open chat
  end?: boolean; // New prop for end chat
}

const ResetModal: React.FC<ResetModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  primaryColor = primary[5],
  open = false,
  end = false,
}) => {
  // Determine modal content based on props
  const getModalContent = () => {
    if (open) {
      return {
        title: "Re-open Chat?",
        message: "Are you sure you want to re-open this chat?",
        subMessage: null,
      };
    }

    if (end) {
      return {
        title: "End Chat?",
        message: "Are you sure you want to end this chat?",
        subMessage: null,
      };
    }

    // Default reset modal content
    return {
      title: "Reset Changes?",
      message: "Are you sure you want to reset the form?",
      subMessage: "All entered data will be lost.",
    };
  };

  const modalContent = getModalContent();

  return (
    <Modal
      withCloseButton={false}
      opened={isOpen}
      onClose={onClose}
      centered
      size='md'
      padding='1rem'
      style={{ borderRadius: 8 }}
    >
      <Stack gap='sm'>
        <Text fw={600} size='lg'>
          {modalContent.title}
        </Text>

        <Text size='16px' fw={600} lh='20px' c='dimmed'>
          {modalContent.message}
        </Text>

        {modalContent.subMessage && (
          <Text size='16px' fw={600} lh='20px' c='dimmed'>
            {modalContent.subMessage}
          </Text>
        )}

        <Group justify='flex-end' mt='lg'>
          <Button variant='outline' c={gray[8]} onClick={onClose} radius='md'>
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            radius='md'
            style={{
              backgroundColor: end
                ? "#EA5455"
                : open
                ? success[6]
                : primaryColor,
              color: "white",
            }}
          >
            {end ? "Yes, End Chat" : open ? "Yes, Re-Open" : "Reset"}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ResetModal;
